import axios from 'axios'
import {
  setFormValues,
  setFilterValues,
  toggleFilterValues,
} from '../../modules/mutations.js'
import { comments, emails, replies, topic_type, statuses } from '../../modules/filterModalConst'

export const companiesSearchTagGroups = {
  namespaced: true,
  state: {
    data: {
      emails: {
        kind: 'emails',
        tags: emails
      },
      replies: {
        kind: 'replies',
        tags: replies
      },
      ratings: {
        kind: 'ratings',
        tags: gon.ratings.map((rating) => {
          return {
            id: rating.value,
            ...rating
          }
        })
      },
      comments: {
        kind: 'comments',
        tags: comments
      },
      topic_types: {
        kind: 'topic_types',
        tags: topic_type
      },
      statuses: {
        kind: 'statuses',
        tags: statuses
      }
    },
    loading: false,
    loadError: false,
    formValues: {},
    changeCheckBox: false,
  },
  getters: {
    loading: (state) => {
      return state.loading
    },
    searchAttributes: (state) => {
      return state.data
    },
    brands: (state) => {
      return state.data.brands
    },
    areas: (state) => {
      return state.data.areas
    },
    franchisees: (state) => {
      return state.data.franchisees
    },
    userCompanies: (state) => {
      return state.data.user_companies
    },
    originalTagGroupA: (state) => {
      return state.data.originalTagGroupA
    },
    originalTagGroupB: (state) => {
      return state.data.originalTagGroupB
    },
    originalTagGroupC: (state) => {
      return state.data.originalTagGroupC
    },
    originalTagGroupD: (state) => {
      return state.data.originalTagGroupD
    },
    originalTagGroupE: (state) => {
      return state.data.originalTagGroupE
    },
    prefectures: (state) => {
      return state.data.prefectures
    },
    formValues: (state) => {
      return state.formValues
    },
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
      state.loadError = false
    },
    readSearchTagGroupsSuccess(state, payload) {
      payload.forEach(v => {
        const attributes = v.attributes
        switch (attributes.kind) {
        case 'keyword_analysis_target':
          attributes.kind = attributes.kind + 's'
          attributes.tags = attributes.tags.map((tag) => { return { id: tag.value, ...tag } })
          break
        case 'user_company':
          attributes.kind = 'user_companies'
          break
        case 'product_category':
          attributes.kind = 'product_categories'
          break
        case 'sns_category':
          attributes.kind = 'sns_categories'
          break
        case 'post_service':
          attributes.kind = 'post_services'
          break
        case 'original_tag_group_a':
          break
        case 'original_tag_group_b':
          break
        case 'original_tag_group_c':
          break
        case 'original_tag_group_d':
          break
        case 'original_tag_group_e':
          break
        default:
          attributes.kind = attributes.kind + 's'
        }
        state.data[attributes.kind] = attributes
      })
      state.loading = false
    },
    readSearchTagGroupsFailure(state) {
      state.loading = false
      state.loadError = true
    },
    setFormValues(state, value) {
      setFormValues(state, value)
      state.changeCheckBox = !state.changeCheckBox
    },

    setFilterValues(state, payload) {
      setFilterValues(state, payload)
      state.changeCheckBox = !state.changeCheckBox
    },
    toggleFilterValues(state, payload) {
      toggleFilterValues(state, payload)
      state.changeCheckBox = !state.changeCheckBox
    }
  },
  actions: {
    readSearchTagGroups({ commit, rootState }, params = {}) {
      commit('prepareConnect')
      params = (params !== null && typeof params === 'object') ? params : {}
      return axios
        .get('/api/companies/' + rootState.route.params.company_uuid + '/search_tag_groups.json', { params: params })
        .then(res => {
          commit('readSearchTagGroupsSuccess', res.data.data)
        })
        .catch(err => {
          commit('readSearchTagGroupsFailure', err)
          commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
          console.error(err)
        })
    },
    setFormValues({ commit }, payload) {
      commit('setFormValues', payload)
    }
  }
}
